import { z } from 'zod'
import { createExpenseSchema } from './create-expense.schema'

export const batchCreateExpensesSchema = z.object({
  expenses: z.array(createExpenseSchema).min(1).max(500),
})

export type BatchCreateExpensesDto = z.infer<typeof batchCreateExpensesSchema>
